import { motion } from "framer-motion";
import { ArrowRight, Star } from "lucide-react";

export default function UnitCard({ unit, onBook, compact = false, i = 0 }) {
  return (
    <motion.article
      className="card-brutal flex flex-col hover:-translate-y-1 hover:shadow-[8px_8px_0_0_#169ED9] transition-[transform,box-shadow] duration-150"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.5, delay: i * 0.05 }}
      data-testid={`unit-card-${unit.id}`}
    >
      <div className="relative bg-white border-b-[3px] border-tpeco-ink flex items-center justify-center h-44 p-3">
        <img src={unit.img} alt={`${unit.brand} ${unit.model} hot water system`} loading="lazy"
          className="max-h-full max-w-full object-contain" />
        <span className="absolute top-2 left-2 chip-brutal bg-tpeco-blue border-tpeco-blue text-white !text-xs !px-2">{unit.id}</span>
        {unit.badge && (
          <span className={`absolute top-2 right-2 chip-brutal !text-xs !px-2 ${unit.badge === "BEST PRICE" ? "bg-tpeco-pink border-tpeco-pink text-white" : "bg-tpeco-ink text-white"}`}>
            {unit.badge === "BEST PRICE" && <Star className="w-3 h-3 fill-white" />}
            {unit.badge}
          </span>
        )}
      </div>
      <div className="p-4 flex flex-col flex-1">
        <span className="text-xs font-extrabold uppercase tracking-widest text-neutral-500">{unit.brand} · {unit.fuel} {unit.system}</span>
        <h3 className="font-display uppercase text-2xl leading-tight mt-1">{unit.model}</h3>
        {!compact && <p className="mt-2 text-xs font-semibold text-neutral-600 line-clamp-2">{unit.blurb}</p>}
        <div className="mt-3 flex items-end justify-between gap-2">
          <div>
            <span className="block text-[10px] font-extrabold uppercase tracking-widest text-neutral-500">SWAP-OUT INSTALLED</span>
            {unit.available ? (
              <span className="font-display text-4xl leading-none text-tpeco-blue" data-testid={`unit-price-${unit.id}`}>${unit.price.toLocaleString()}</span>
            ) : (
              <span className="font-display text-2xl leading-none text-neutral-400">N/A</span>
            )}
          </div>
          <span className="chip-brutal bg-tpeco-smoke !text-xs !px-2 whitespace-nowrap">{unit.people}</span>
        </div>
        <span className="mt-2 text-[11px] font-bold text-neutral-500 uppercase tracking-wide">{unit.warranty}</span>
        <button
          onClick={() => onBook(unit)}
          disabled={!unit.available}
          data-testid={`book-unit-${unit.id}`}
          className={`mt-4 ${unit.available ? "btn-brutal" : "btn-brutal opacity-40 cursor-not-allowed"} w-full !text-lg !py-2`}
        >
          BOOK THIS SWAP <ArrowRight className="w-4 h-4" strokeWidth={2.5} />
        </button>
      </div>
    </motion.article>
  );
}
